import fr from 'facet-rest';
import RichTextEditor from 'Components/UI/RichTextEditor';
import RichTextEditorCustomContextMenu from 'Components/UI/RichTextEditorCustomContextMenu';

const hiddenFieldNames = ['content', 'agentId', 'subject', 'templateType'];


export const TemplateTableOverride = fr.metaOverride()
  .overrideAll({
    readonly: true,
    _hideLabel: true,
    _customProps: {
      noWrap: true,
      hasTooltip: true,
    },
  })
  .nameOverride(name => hiddenFieldNames.includes(name), { hidden: true })
  .nameOverride('name', { ordinal: 0 })
  .nameOverride('description', { ordinal: 2 })
  .nameOverride('enabled', { ordinal: 4 });


export const TemplateEditOverride = fr.metaOverride()
  .nameOverride('agentId', { hidden: true })
  .nameOverride('templateType', { hidden: true })
  .nameOverride('name', { ordinal: 0 })
  .nameOverride('description', { ordinal: 2 })
  .nameOverride('enabled', { ordinal: 4 })
  .nameOverride('subject', { ordinal: 6 })
  .nameOverride('content', {
    ordinal: 8,
    _component: () => RichTextEditorCustomContextMenu,
    _customProps: {
      size: 'md',
      agentOnly: true,
    },
  });

export const TemplateNoteEditOverride = fr.metaOverride()
  .nameOverride('agentId', { hidden: true })
  .nameOverride('subject', { hidden: true })
  .nameOverride('templateType', { hidden: true })
  .nameOverride('name', { ordinal: 0 })
  .nameOverride('description', { ordinal: 2 })
  .nameOverride('enabled', { ordinal: 4 })
  .nameOverride('content', {
    ordinal: 8,
    _component: () => RichTextEditor,
    _customProps: {
      size: 'md',
    },
  });
